export default "__VITE_ASSET__0c83acad__"